import { Link, Typography } from "@mui/material";

interface Props{
    text: string
}

export const TextWithLinks = (props: Props) => {
    const urlRegex = /(https?:\/\/[^\s]+)/g;
    const parts = props.text?.split(urlRegex);
  
    return (
      <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>
        {parts?.map((part, index) =>
          urlRegex?.test(part) ? (
            <Link
              key={index}
              href={part}
              target="_blank"
              rel="noopener noreferrer"
              sx={{ color: "blue", textDecoration: "underline" }}
            >
              {part}
            </Link>
          ) : (
            part
          )
        )}
      </Typography>
    );
  };